import moment from 'moment';

const app = {
  state: {
    environment: process.env.NODE_ENV,
    sessionExpired: false,
    menuSelected: '/',
    empresaSelected: null,
    breadcrumb: [],
    masterTablesLoaded: false,
    timeLastAPICall: null,
    loading: false
  },
  mutations: {
    SET_ENVIRONMENT: (state, environment) => {
      state.environment = environment;
    },
    SET_SESSION_EXPIRED: (state, sessionExpired) => {
      state.sessionExpired = sessionExpired;
    },
    SET_MENU_SELECTED: (state, menuSelected) => {
      state.menuSelected = menuSelected;
    },
    SET_EMPRESA: (state, empresaSelected) => {
      state.empresaSelected = empresaSelected;
    },
    SET_BREADCRUMB: (state, breadcrumb) => {
      state.breadcrumb = breadcrumb;
    },
    SET_MASTER_TABLES_LOADED: (state, masterTablesLoaded) => {
      state.masterTablesLoaded = masterTablesLoaded;
    },
    SET_TIME_LAST_API_CALL: (state, timeLastAPICall) => {
      state.timeLastAPICall = timeLastAPICall;
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading;
    }
  },
  actions: {
    setMenuSelected({ commit }, menuSelected) {
      commit('SET_MENU_SELECTED', menuSelected);
    },
    setEmpresaSelected({ commit }, empresaSelected) {
      commit('SET_EMPRESA', empresaSelected);
    },
    setBreadcrumb({ commit }, payload) {
      commit('SET_BREADCRUMB', payload.breadcrumb);
      commit('SET_MENU_SELECTED', payload.menuSelected);
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading);
    },
    clearMasterTables({ commit }) {
      commit('SET_MASTER_TABLES_LOADED', false);
    },
    setTimeLastAPICall({ commit }) {
      commit('SET_TIME_LAST_API_CALL', moment());
    },
    sessionExpired({ commit }, sessionExpired) {
      commit('SET_SESSION_EXPIRED', sessionExpired);
    }
  }
};

export default app;
